import { IUpdateHabilidadeUseCase } from "../../../presentation/useCases/update/update_habilidade_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * UpdateHabilidadeUseCase
 */

export class UpdateHabilidadeUseCase implements IUpdateHabilidadeUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async updateHabilidade(
    idHabilidade: number,
    descricao: string,
    habilidade: string,
  ): Promise<void> {
    await this.repository.updateHabilidade(
      idHabilidade,
      habilidade,
      descricao,
    );
  }
}
